<template>
  <div class="topBox" :style="isLine?'border-bottom:1px solid #ddd':'border-bottom:0'">
    <div class="topTitle">{{ topTitle }}</div>
    <div class="topMore" v-if="isJptj" @click="goJptjDetail"><a>更多>></a></div>
    <div class="topMore" v-else><a :href="topMore" target="_black">更多>></a></div>
  </div>
</template>

<script>
export default {
  name: "topBox",
  props: {
    topTitle: String,
    topMore: String,
    isLine:Boolean,
    isJptj:Boolean
  },
  data() {
    return {};
  },
  methods:{
    goJptjDetail(){
      this.$router.push({
        name:"imgDetail"
      })
    }
  }
};
</script> 

<style scoped lang="scss">
.topBox {
  height: 39px;
  border-bottom: 1px solid #ddd;
  .topTitle {
    float: left;
    font-size: 18px;
    color: #ba2a17;
    font-weight: 600;
  }
  .topMore {
    float: right;
    font-size: 12px;
    line-height: 28px;
    font-weight: 600;
    a {
      color: #999;
      &:hover {
        cursor: pointer;
        color: #ba2a17;
      }
    }
  }
}
</style>
